import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnInput } from "../../../library-js/dom-tools/EventListeners";
import { Enums } from "../../../library-js/tools/Enums";
import { InspectorField } from "../fields/InspectorField";
import { EnumMap } from "../../../library-js/tools/EnumMap";
import { EnumValue } from "./EnumValue";
import { InspectorNameTransformer } from "../InspectorNameTransformer";

export class EnumValueField extends InspectorField<EnumValue<any>>
{
  static readonly type = new ElementType( "enum--value--field" );

  protected _selectElement:HTMLSelectElement;

  constructor( enumValue:EnumValue<any> )
  {
    super();
    this._value = enumValue;
  }

  createElement() 
  {
    let element = EnumValueField.type.create();
    InspectorField.flag.set( element );

    let selectElement = ElementType.select.create();

    this._selectElement = selectElement;
    

    let enumMap = this._value.enumMap;
    enumMap.names.forEach(
      ( n )=>
      {
        let name = n;

        name = InspectorNameTransformer.convert( name );
        
        let option = ElementType.option.create( name );
        option.value = n;

        selectElement.appendChild( option );
      }
    )


    element.appendChild( selectElement );

    OnInput.add( selectElement,
      ()=>
      {
        this.value.value = this._value.enumMap.keys[ this._selectElement.selectedIndex ];
        this.onChange.dispatch( this.value );

        console.log( "CHANGED ENUM:", this.value, this._selectElement.selectedIndex );
      }
    );

    this._element = element;
  }

  syncValueToElement()
  {
    let enumValue = this.value.value;

    let selectedIndex = this.value.enumMap.keys.indexOf( enumValue );

    this._selectElement.selectedIndex = selectedIndex;
  }
}